import { render, staticRenderFns } from "./help.vue?vue&type=template&id=2554be40&scoped=true&lang=html&"
import script from "./help.vue?vue&type=script&lang=js&"
export * from "./help.vue?vue&type=script&lang=js&"
import style0 from "./help.vue?vue&type=style&index=0&id=2554be40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2554be40",
  null
  
)

component.options.__file = "help.vue"
export default component.exports